import { render, staticRenderFns } from "./ArchivedPlansHome.vue?vue&type=template&id=4782581c"
import script from "./ArchivedPlansHome.vue?vue&type=script&lang=js"
export * from "./ArchivedPlansHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports